var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('WebViewer',{attrs:{"path":`${_vm.publicPath}lib`,"url":"https://pdftron.s3.amazonaws.com/downloads/pl/webviewer-demo.pdf"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }